import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import PhaseType from 'types/phase';

export const appointment_scheduled = ({ event: { kind, data } }) => {
  const { start_date, end_date, arrival_start_time, arrival_end_time, assignee,
          scheduling_reason, source = '', ignored_warnings = [] } = data;
  const arrivalStartTime = arrival_start_time.substr(0, arrival_start_time.length - 6);
  const arrivalEndTime = arrival_end_time.substr(0, arrival_end_time.length - 6);
  let date = moment(start_date).format('MM/DD/YYYY');
  if (end_date !== start_date) date += `—${moment(end_date).format('MM/DD/YYYY')}`;
  const start = moment(arrivalStartTime).format('h:mm a');
  const end = moment(arrivalEndTime).format('h:mm a');
  return (<div className={kind}>
    <p><strong>Scheduling Reason:</strong> {scheduling_reason || 'N/A'}</p>
    {source === 'suggestion' && <p>Scheduled using appt. suggestions.</p>}
    {(ignored_warnings || []).length > 0 && <p>
      <strong>WARNING:</strong> {ignored_warnings.join(', ')}.
    </p>}
    {assignee} scheduled for {date} with arrival between {start} and {end}.
  </div>);
};

appointment_scheduled.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      appointment_type: PropTypes.string.isRequired,
      start_date: PropTypes.string.isRequired,
      end_date: PropTypes.string.isRequired,
      arrival_start_time: PropTypes.string.isRequired,
      arrival_end_time: PropTypes.string.isRequired,
      assignee: PropTypes.string.isRequired,
      scheduling_reason: PropTypes.string,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/appointment_scheduled.jsx